<script>
  import Group from "$lib/admin/components/Group.svelte";
  import Input from "$lib/admin/components/Input.svelte"
  import Manage from "$lib/admin/components/Manage.svelte";
  import Button from "$lib/main/components/Button.svelte";
  import Heading from '$lib/admin/components/blocks/helpers/Heading.svelte';

  export let props = null
  export let adminView = false

  function addRepeatableField() {
    if(!Array.isArray(props.tableContent)) props.tableContent = []
    const field = [[]]
    props.tableContent.push(field)
    // TODO: using below function to update the preview does not seem to work
    props = props
  }

  function removeRepeatableField(fieldIndex) {
    props.tableContent.splice(fieldIndex, 1)
    // TODO: using below function to update the preview does not seem to work
    props = props
  }

  function createHeaders() {
    if(!Array.isArray(props.tableHeaders)) props.tableHeaders = ["test"]
    props = props
  }
</script>

{#if adminView}
  <Group addClass="form-item">
    <!-- svelte-ignore a11y-label-has-associated-control -->
    <Group><label>Table headers</label></Group>
    {#if props.tableHeaders && props.tableSingleHeader}
      <Group>
        <Input
          placeholder="Header text"
          bind:value={props.tableHeaders[0]}
          on:keyup />
      </Group>
    {:else if props.tableHeaders}
      <Group colspan={ props.tableColumns }>
        {#each {length: props.tableColumns} as _, i}
          <Input
            placeholder="Header text"
            bind:value={props.tableHeaders[i]}
            on:keyup />
        {/each}
      </Group>
    {:else}
      <!-- TODO:
        this is a super hacky way of creating the tableHeaders array.
        Possible to have this done when adding the component directly?
      -->
      <button on:click={() => createHeaders()}>Create headers</button>
    {/if}
  </Group>
  <Group colspan="1-11" addClass="form-item">
    <Input
      label="Single table header"
      type="checkbox"
      bind:checked={props.tableSingleHeader} />
  </Group>
  <Group colspan="8-4" addClass="form-item">
    <!-- TODO: min/max here does not seem to be working.. -->
    <Input
      label="Table columns"
      id="length"
      type="number"
      min="2"
      max="3"
      bind:value={props.tableColumns} />
  </Group>
  {#if props.tableContent}
    {#each props.tableContent as item, fieldIndex}
      <Group colspan="1-auto" addClass="form-item">
        <Group colspan={ props.tableColumns }>
          {#each {length: props.tableColumns} as _, i}
            <Input
              placeholder="Cell content {i + 1}"
              bind:value={item[i]}
              on:keyup />
          {/each}
        </Group>
        <Button
          addClass="secondary"
          onlyIcon
          icon="trash-2"
          on:click={() => removeRepeatableField(fieldIndex)}
          />
      </Group>
    {/each}
  {/if}
  <Group addClass="form-item manage">
    <Manage>
      <Button addClass="primary" on:click={() => addRepeatableField()}>Add table row</Button>
    </Manage>
  </Group>
{:else}
  <div class="block block-table-basic" class:scroll={ props.tableColumns > 2}>
    <div class="container">
      <div class="grid">
        <div class="g-col-12 g-start-1 g-col-md-10 g-start-md-2">
          <Heading {props} />

          <div class="table-container">
            <table>
              <thead>
                <tr>
                  {#if props.tableSingleHeader}
                    <th colspan="{ props.tableColumns }">{ props.tableHeaders }</th>
                  {:else}
                    {#if props.tableHeaders}
                      {#each props?.tableHeaders as header}
                        <th>{ header }</th>
                      {/each}
                    {/if}
                  {/if}
                </tr>
              </thead>
              <tbody>
                {#if props.tableContent}
                  {#each props.tableContent as row}
                    <tr>
                      {#each row as cellContent}
                        <td>{@html cellContent }</td>
                      {/each}
                    </tr>
                  {/each}
                {/if}
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
{/if}

<style>
  .block-table-basic.scroll .grid .table-container {
    display: block;
    overflow-x: auto;
  }
  .block-table-basic.scroll .grid .table-container::-webkit-scrollbar {
    display: none;
  }
  .block-table-basic .grid .table-container {
    background: var(--bg-clr-alt);
    border-radius: var(--bd-rad);
    padding: 0.625rem;
    margin: 0 0 1rem 0;
  }
  .block-table-basic table {
    width: 100%;
    border-collapse: collapse;
    overflow: hidden;
    font-size: 1rem;
    border-radius: var(--bd-rad-sm);
  }
  .block-table-basic table thead {
    background: var(--clr-ter);
    color: var(--clr-ter-txt);
  }
  .block-table-basic table thead tr th {
    padding: 0.9375rem;
  }
  .block-table-basic.scroll table thead tr th {
    text-align: left;
  }
  .block-table-basic table thead tr th:first-of-type {
    border-top-left-radius: var(--bd-rad-sm);
  }
  .block-table-basic table thead tr th:last-of-type {
    border-top-right-radius: var(--bd-rad-sm);
  }
  .block-table-basic table tbody tr td {
    background: var(--bg-clr);
    padding: 0.625rem 0.9375rem;
    font-weight: 300;
  }
  .block-table-basic table tbody tr:last-of-type td:first-of-type {
    border-bottom-left-radius: var(--bd-rad-sm);
  }
  .block-table-basic table tbody tr:last-of-type td:last-of-type {
    border-bottom-right-radius: var(--bd-rad-sm);
  }
  .block-table-basic table tbody tr:nth-of-type(even) td {
    background: var(--bg-clr-alt-2);
  }

  @media (min-width: 768px) {
    .block-table-basic table {
      font-size: 1.25rem;
    }
  }
</style>